// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"AtendimentoRestritoGer_containerPrincipal__NpQp9","divConvenios":"AtendimentoRestritoGer_divConvenios__9JCHF","botao":"AtendimentoRestritoGer_botao__CAwx5"};